import React from "react";
import { Route, Routes } from "react-router-dom";
import PackagedList from './Project/PackagedList';


class PackagedProjectsRegisterRouter extends React.Component {
    constructor(props) {
        super(props);
        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
        this.projectOrderFields = (this.props.workflowsQA['72'] || {}).fields;
        console.log('PackagedProjectsRegisterRouter props', this.projectOrderFields);

    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;


        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<PackagedList
                        {...this.props}
                        contractTemplate={this.props.contractTemplate}
                        contractUser={this.props.contractUser}
                        title={workflowItem.pageTitle}
                        projectOrderFields={this.projectOrderFields}
                    />}
                />
            </Routes>
        );
    }
};




export default (PackagedProjectsRegisterRouter);